import styled from 'styled-components';

import { color, compose, space, typography } from 'styled-system';

const svgsystem = compose(color, space, typography);

export default (icon: SVGComponent) => styled(icon)(svgsystem);
